import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { setAlert } from '../../../actions/alert';
import { buscarPaquetesConfiguracion } from '../../../actions/configuracion';

import { formatNumber } from '../../../utils/generalFunctions';

import NuevoPaquete from './NuevoPaquete';
import EditarPaquete from './EditarPaquete';
import EliminarPaquete from './EliminarPaquete';

const Paquetes = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Paquetes',
            path: '/configuracion/paquetes'
        }
    ];

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.configuracion.paquetes);

    const [paquetes, setPaquetes] = useState([]);

    const [paqueteAgregar, setPaqueteAgregar] = useState(null);
    const [paqueteEditar, setPaqueteEditar] = useState(null);
    const [paqueteEliminar, setPaqueteEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => row.nombre,
        }, 
        {
            name: 'Precio',
            selector: row => formatNumber(row.precio, 2, '$ ', '')
        },
        {
            name: 'Comision',
            selector: row => formatNumber(row.comision, 2, '', ' %')
        },
        {
            name: 'Servicios',
            sortable: true, 
            selector: row => row.servicios?.length,
        },
        {
            name: 'Contrataciones',
            sortable: true, 
            selector: row => row.contrataciones,
        },
        {
            name: 'Descripción',
            selector: row => row.descripcion,
            grow: 2, 
            wrap: true
        },
        {
            name: '',
            cell: row => {
                if(row._id){
                    return(
                        <div className="text-right w-100">
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarPaquete(row)}><i className="fas fa-trash text-danger"></i></button>
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarPaquete(row)}><i className="fas fa-edit text-warning"></i></button>
                        </div>
                    )
                }else{
                    return(<></>)
                }
            }
        }
    ];

    /* Crear paquete */
    const handleAgregarPaquete = (paquete) => {
        setPaqueteEditar(null);
        setPaqueteEliminar(null);

        setPaqueteAgregar(paquete);        
    }

    /* Editar paquete */
    const handleEditarPaquete = (paquete) => {
        setPaqueteAgregar(null);
        setPaqueteEliminar(null);

        setPaqueteEditar(paquete);
    }

    /* Eliminar paquete */
    const handleEliminarPaquete = (paquete) => {
        if(paquete?.contrataciones){
            dispatch(setAlert('No se puede eliminar porque ya fue contratado', 'danger'));
        }else{
            setPaqueteAgregar(null);
            setPaqueteEditar(null);

            setPaqueteEliminar(paquete);
        }
    }

    useEffect(() => {
        dispatch(buscarPaquetesConfiguracion());
    }, []);

    useEffect(() => {
        setPaquetes(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <NuevoPaquete paquete={paqueteAgregar} reestablecerPaquete={handleAgregarPaquete} />
            <EditarPaquete paquete={paqueteEditar} reestablecerPaquete={handleEditarPaquete} />
            <EliminarPaquete paquete={paqueteEliminar} reestablecerPaquete={handleEliminarPaquete} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Paquetes</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarPaquete({ })}>Agregar paquete</button>
                    </div>

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={paquetes}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Paquetes;